module.exports = __webpack_public_path__ + "img/PGR_A05_front_cross_diagonal_horizontal_en.a63474b1.png";